import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';
export const SERVER_API_URL = environment.serverUrl;
const routes = {
  live: {
    getLiveNegotiationList: (id: any, id1: any) => `${SERVER_API_URL}/api/v1/getNegotiationsVendorWise/${id}/${id1}`,
    getVendorQuoteHistory: (id: any, id1:any) => `${SERVER_API_URL}/api/v1/getVendorWiseItemsDetails/${id}/${id1}`,
    createVendorNegotiation:() => `${SERVER_API_URL}/api/v1/vendorNegotiation`,
    getYourQuote:(id:any,id1:any) => `${SERVER_API_URL}/api/v1/getNegotiationHistoryById/${id}/${id1}`,
    getDataOnnegotiationFrequencyId:() => `${SERVER_API_URL}/api/v1/getDataOnnegotiationFrequencyId`
    
  },
  closed:{
    getClosedList:(id:any) =>`${SERVER_API_URL}/api/v1/getClosedVendorNegotiation/${id}`
  }
};
@Injectable({
  providedIn: 'root'
})
export class vendornegotiationservice {
  constructor(private readonly http: HttpClient) {
  }

  getLiveNegotiationList(id: any, id1: any): Observable<any> {
    return this.http.get<any>(routes.live.getLiveNegotiationList(id, id1), { observe: 'response' })
  }
  getYourQuote(id: any, id1: any): Observable<any> {
    return this.http.get<any>(routes.live.getYourQuote(id, id1), { observe: 'response' });
  }
  createVendorNegotiation(data: any): Observable<any> {
    return this.http.post<any>(routes.live.createVendorNegotiation(), data, { observe: 'response' });
  }
  getVendorHistory(id: any, id1:any): Observable<any> {
    return this.http.get<any>(routes.live.getVendorQuoteHistory(id, id1), { observe: 'response' });
  }
  getDataOnnegotiationFrequencyId(id: any): Observable<any> {
    return this.http.post<any>(routes.live.getDataOnnegotiationFrequencyId(),id, { observe: 'response' });
  }
  
  getClosedNegotiationList(id: any): Observable<any> {
    return this.http.get<any>(routes.closed.getClosedList(id), { observe: 'response' });
  }
}
